import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { formatNumber } from "@/lib/utils";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type A5DerivativeUnderlyings = {
  id: number;
  structured_product_id?: number;
  structured_product_name?: string;
  underlying_id?: number;
  underlying_name?: string;
  initial_strike_price?: number;
  weight?: number;
  created_at: Date;
  updated_at: Date;
};

export const derivative_underlyings_columns: ColumnDef<A5DerivativeUnderlyings>[] =
  [
    {
      accessorKey: "id",
      header: () =>
        i18n.t("a5_derivative_underlyings.columns.id", {
          ns: "tables",
          defaultValue: "Id",
        }),
    },
    {
      accessorKey: "underlying_name",
      header: () =>
        i18n.t("a5_derivative_underlyings.columns.underlying_name", {
          ns: "tables",
          defaultValue: "Sous-jacent",
        }),
      cell: ({ row }) => {
        return (
          <ExternalLink
            href={toWorkspacePath(
              `/admin/a5/a5_static_data/${row.original.underlying_id}`,
            )}
            className="text-xs"
            underline="hover"
          >
            {row.getValue("underlying_name")}
          </ExternalLink>
        );
      },
    },
    {
      accessorKey: "structured_product_name",
      header: () =>
        i18n.t("a5_derivative_underlyings.columns.structured_product_name", {
          ns: "tables",
          defaultValue: "Produit structuré",
        }),
      cell: ({ row }) => {
        return (
          <ExternalLink
            href={toWorkspacePath(
              `/admin/a5/a5_static_data/${row.original.structured_product_id}`,
            )}
            className="text-xs"
            underline="hover"
          >
            {row.getValue("structured_product_name")}
          </ExternalLink>
        );
      },
    },
    {
      accessorKey: "weight",
      header: () => (
        <div className="text-right">
          {i18n.t("a5_derivative_underlyings.columns.weight", {
            ns: "tables",
            defaultValue: "Pondération",
          })}
        </div>
      ),
      cell: ({ row }) => {
        return (
          <div className="text-right">
            {formatNumber(row.getValue("weight"))}
          </div>
        );
      },
    },
    {
      accessorKey: "initial_strike_price",
      header: () => (
        <div className="text-right">
          {i18n.t("a5_derivative_underlyings.columns.initial_strike_price", {
            ns: "tables",
            defaultValue: "Prix de strike initial",
          })}
        </div>
      ),
      cell: ({ row }) => {
        return (
          <div className="text-right">
            {formatNumber(row.getValue("initial_strike_price"))}
          </div>
        );
      },
    },
    {
      id: "actions",
      cell: ({ row }) => {
        return (
          <div className="flex gap-3 justify-end">
            <Link
              href={`${window.location.pathname}/${row.getValue("id")}`}
              className="text-xs"
              underline="hover"
            >
              {i18n.t("actions.edit")}
            </Link>
          </div>
        );
      },
    },
  ];

// export const derivative_underlyingss_audit_columns = getAuditColumns<A5DerivativeUnderlyings>(derivative_underlyingss_columns)
